export default __webpack_public_path__ + "static/media/higher_primary_hi_ident_tagline_reversed.4a724f68.svg";